import { SecondaryStatusTag } from "@graffer-inc/console-design-kit";
import { SummarizedPaymentStatus } from "../../application/domain/application/application-entity";

export interface PaymentsStatusTagProps {
  status: SummarizedPaymentStatus;
}

export const PaymentsStatusTag = ({ status }: PaymentsStatusTagProps) => {
  switch (status) {
    case "CANCELLED":
      return (
        <p className="ml-2 mt-auto mb-auto">
          <SecondaryStatusTag type={"DARK"}>決済キャンセル</SecondaryStatusTag>
        </p>
      );
    case "WAITING":
      return (
        <p className="ml-2 mt-auto mb-auto">
          <SecondaryStatusTag type={"LIGHT"}>決済待ち</SecondaryStatusTag>
        </p>
      );
    case "DONE":
      return (
        <p className="ml-2 mt-auto mb-auto">
          <SecondaryStatusTag type={"SUCCESS"}>決済完了</SecondaryStatusTag>
        </p>
      );
    case "EXCEEDING_PAYMENT":
      return (
        <p className="ml-2 mt-auto mb-auto">
          <SecondaryStatusTag type={"ERROR"}>過入金</SecondaryStatusTag>
        </p>
      );
    case "DEFICIENCY_PAYMENT":
      return (
        <p className="ml-2 mt-auto mb-auto">
          <SecondaryStatusTag type={"ERROR"}>入金不足</SecondaryStatusTag>
        </p>
      );
    default:
      return null;
  }
};
